// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "title-3hNyI";
var _3 = "currentSorting-3yjzF";
var _4 = "mobile__list__button-3gYRc";
var _5 = "switch__label-31OIK";
var _6 = "mobile__list__button_inactive-3-VHs";
export { _1 as "__esModule", _2 as "title", _3 as "currentSorting", _4 as "mobile__list__button", _5 as "switch__label", _6 as "mobile__list__button_inactive" }
export default { "__esModule": _1, "title": _2, "currentSorting": _3, "mobile__list__button": _4, "switch__label": _5, "mobile__list__button_inactive": _6 }
